/******/ (() => { // webpackBootstrap
// CART-REMOVAL-FIX :: build input - does NOT deploy. Deploy assets/z__jsCart.js instead.
// Part of the "remove item from basket" fix: key-based removal, idempotent init, and the
// self-init fallback at the bottom of this file.
window.PXUTheme.jsCart = {
  init: function ($section) {
    // Add settings from schema to current object
    //window.PXUTheme.jsCart = $.extend(this, window.PXUTheme.getSectionData($section));

    this.$section = $section;

    // The click handlers below are delegated on document, so they must be bound exactly
    // once. init() can legitimately be called more than once: app.js's document-ready
    // loop, the theme editor's shopify:section:load, and the self-init fallback at the
    // bottom of this file can each reach it. Binding twice would fire two
    // /cart/change.js requests per click and remove two lines.
    if (this.handlersBound) return;
    this.handlersBound = true;

    $(document).on("click", "[data-cart-page-delete]", function (e) {
      e.preventDefault();
      // Read with attr(), not data(): jQuery's data cache is populated on first read and
      // does not see the attribute rewrites updateView() makes, so data() can go stale.
      const itemKey = $(this).attr("data-cart-item-key");
      window.PXUTheme.jsCart.removeFromCart(itemKey);

      return false;
    });

    // Prevent the ajax cart form from being submitted when pressing the "Enter" key
    $("#cart_form").keydown(function (e) {
      if (e.keyCode == 13) {
        e.preventDefault();
        return false;
      }
    });
  },
  // itemKey is a line item key (`<variant_id>:<hash>`), not a positional line number.
  removeFromCart: function (itemKey) {
    const $cartItem = window.PXUTheme.jsCart.$section.find(`[data-cart-item="${itemKey}"]`);

    // updateView() still addresses rows positionally, so capture the row's current index
    // before it is detached.
    const lineID = $cartItem.attr("data-line-item") || null;

    $cartItem.css("opacity", "0.5");

    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: { id: itemKey, quantity: 0 },
      dataType: "json",
      success: function (cart) {
        $cartItem.addClass("animated zoomOut");
        $cartItem.remove();

        window.PXUTheme.jsCart.updateView(cart, lineID);

        if (typeof window.PXUTheme.jsAjaxCart !== "undefined") {
          window.PXUTheme.jsAjaxCart.updateView();
        }
      },
      error: function (XMLHttpRequest, textStatus) {
        $cartItem.css("opacity", "");
        window.PXUTheme.jsCart.logCartError("remove", XMLHttpRequest);
      },
    });
  },
  // Shopify returns a JSON body with a `description` on cart errors, but an aborted or
  // network-level failure leaves responseText empty. The previous eval('(' + ... + ')')
  // threw a SyntaxError in that case, so every failure was silent.
  logCartError: function (action, XMLHttpRequest) {
    let description = "";

    try {
      description = (JSON.parse(XMLHttpRequest.responseText) || {}).description || "";
    } catch (error) {
      description = XMLHttpRequest.responseText || XMLHttpRequest.statusText || "";
    }

    console.error(`Cart: ${action} failed (status ${XMLHttpRequest.status}). ${description}`);

    return description;
  },
  updateView: function (cart, lineID) {
    if (cart.item_count > 0) {
      $.ajax({
        dataType: "json",
        async: false,
        cache: false,
        dataType: "html",
        url: "/cart",
        success: function (html) {
          if (lineID !== null) {
            const updatedItems = $(html).find(".cart__item-list .cart__card");
            const currentItems = $(".cart__item-list .cart__card");

            // Checks if BOGO applied and there is a change in the number of line items
            if (updatedItems.length != currentItems.length) {
              const updatedCartList = $(html).find(".cart__item-list");
              // Re-append cart items
              $(".cart__item-list").replaceWith(updatedCartList);
            }

            $(currentItems).each(function (index, element) {
              $(element).attr("data-line-item", index + 1);
              $(element)
                .find("[data-line-item-key]")
                .attr("data-line-item-key", index + 1);
            });

            const itemTotal = $(html).find(`[data-line-item="${lineID}"]`).find(".cart__total");
            const quantityInput = $(html).find(`[data-line-item="${lineID}"]`).find(".quantity-input");
            const itemPrice = $(html).find(`[data-line-item="${lineID}"]`).find(".cart__price");

            $(`[data-line-item="${lineID}"]`).find(".cart__total").replaceWith(itemTotal);
            $(`[data-line-item="${lineID}"]`).find(".quantity-input").replaceWith(quantityInput);
            $(`[data-line-item="${lineID}"]`).find(".cart__price").replaceWith(itemPrice);
          }

          const subtotal = $(html).find(".cart__subtotal-container");
          const discounts = $(html).find(".cart__discounts");
          const savings = $(html).find(".cart__total-savings");

          $(".cart__subtotal-container").replaceWith(subtotal);

          if (discounts.length > 0 && $(".cart__discounts").length < 1) {
            $(".cart__subtotal-container").before(discounts);
          } else {
            $(".cart__discounts").replaceWith(discounts);
          }

          if (savings.length > 0 && $(".cart__total-savings").length < 1) {
            $(".cart__subtotal-container").after(savings);
          } else {
            $(".cart__total-savings").replaceWith(savings);
          }

          $('[data-bind="itemCount"]').text(cart.item_count);
        },
      });
    } else {
      $(".cart__empty-cart-message").removeClass("is-hidden");
      $(".cart__form").addClass("is-hidden");
      $("[data-ajax-cart-trigger]").removeClass("has-cart-count");
      $('[data-bind="itemCount"]').text("0");
    }
  },
  unload: function ($section) {
    // Clear event listeners in theme editor
    $("[data-cart-page-delete]").off();
    $("#cart_form").off();
  },
};

// Self-init fallback.
//
// app.js initialises sections from a single document-ready loop that silently skips any
// section whose script has not executed yet (`window.PXUTheme[triggerClass] && ...init()`).
// This file is loaded with `defer` from the section markup, which normally guarantees it
// runs before DOMContentLoaded - but a third-party app on this store re-injects the
// theme's script tags dynamically, and dynamically inserted scripts are async. When this
// copy lands after jQuery ready, app.js has already run its loop and skipped jsCart, so
// no click handler is ever bound and the remove buttons do nothing.
//
// init() is idempotent (see handlersBound), so it is safe to call here regardless of
// whether app.js got there first.
(function () {
  if (!window.jQuery) return;

  function initIfNotAlready() {
    jQuery(".shopify-section.jsCart").each(function () {
      window.PXUTheme.jsCart.init(jQuery(this));
    });
  }

  if (jQuery.isReady) {
    initIfNotAlready();
  } else {
    jQuery(initIfNotAlready);
  }
})();

/******/ })()
;